import utils from "../../../utils/utils.js";

export default {
  async fetchSuperUsers(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetSuperUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setSuperUsers", responseData.data);
  },

  async fetchUserByNtUserName(context, payload) {
    const response = await utils.utility.fetch(
      `api/Setting/GetUserByNtUserName?ntUserName=${payload.ntUserName}`,
      "GET",
      null,
      null
    );
    context.commit("setSearchResultUser", response.data);
  },

  async postSuperUser(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateSuperUser`,
      "POST",
      null,
      payload
    );
  },
  async deleteSuperUser(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/RemoveSuperUser`,
      "POST",
      null,
      postData
    );
  },
};
